import React from 'react';
import { useNavigate } from 'react-router-dom';

interface ListingSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  listingId?: string | null;
}

const ListingSuccessModal: React.FC<ListingSuccessModalProps> = ({ isOpen, onClose, listingId }) => {
  const navigate = useNavigate();
  if (!isOpen) return null;

  const goToMarketplace = () => {
    onClose();
    navigate('/marketplace');
  };
  const viewListing = () => {
    if (!listingId) return;
    onClose();
    navigate(`/product/${listingId}`);
  };
  const goToDashboard = () => {
    onClose();
    navigate('/seller-dashboard');
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
        <div className="flex items-center justify-center mb-4">
          <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
            <i className="ri-check-line text-green-600 text-2xl"></i>
          </div>
        </div>
        <h2 className="text-xl md:text-2xl font-semibold text-center mb-2">Listing done</h2>
        <p className="text-center text-gray-600 mb-6">Visit the marketplace to view your listing or watch progress on your dashboard.</p>
        <div className="flex flex-col gap-3">
          <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" onClick={goToMarketplace}>
            Visit Marketplace
          </button>
          <button className="px-4 py-2 border border-gray-300 text-gray-800 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" onClick={viewListing} disabled={!listingId}>
            View Your Listing
          </button>
          <button className="px-4 py-2 border border-gray-300 text-gray-800 rounded-lg hover:bg-gray-50 transition-colors" onClick={goToDashboard}>
            Watch Progress on Dashboard
          </button>
          <button className="px-4 py-2 text-gray-500 hover:text-gray-700" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default ListingSuccessModal;